import { faCommentAlt } from "@fortawesome/pro-regular-svg-icons/faCommentAlt";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@vapor/react-material";
import Button from "@vapor/react-material/Button";
import Stack from "@vapor/react-material/Stack";
import {
  faEllipsisVertical,
  faFileArrowDown,
} from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "@onefront/react-sdk";
import CardPopover from "../../../documents/document-components/CardPopover";
import { useDocumentList } from "../../state/useDocumentList";

const ActionCell = ({
  anchorEl,
  changeDocumentStatus,
  doc,
  handleClick,
  handleClickModal,
  handleCloseActionsPopup,
  handleDocumentsDelete,
  handleDocumentRestore,
  handleMoveToBin,
  isDeleteDocumentsLoading,
  isMoveToBinLoading,
  loadingChangeDocumentStatus,
  open,
  restoreLoading,
  workspaceId,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation("DOCS");
  const { documentFilterOption } = useDocumentList();

  return (
    <>
      <Stack
        alignItems="center"
        direction="row"
        justifyContent="flex-end"
        sx={{ height: "100%", minHeight: "68px" }}
      >
        {documentFilterOption !== "CESTINO" && (
          <>
            <Tooltip arrow placement="top" title={t("classification.open")}>
              <Button
                endIcon={
                  <FontAwesomeIcon
                    icon={faCommentAlt}
                    style={{ fontSize: "16px" }}
                  />
                }
                onClick={() =>
                  navigate(
                    `/document-details/${doc.documentId}/${workspaceId}`,
                    {
                      state: { expandComment: true },
                    }
                  )
                }
              />
            </Tooltip>
            <Tooltip arrow placement="top" title={t("document.download")}>
              <Button
                endIcon={
                  <FontAwesomeIcon
                    icon={faFileArrowDown}
                    key={doc.documentId}
                    style={{ fontSize: "16px" }}
                  />
                }
                onClick={(e) => {
                  e.stopPropagation();
                  handleClick(e);
                }}
              />
            </Tooltip>
          </>
        )}
        <Button
          endIcon={<FontAwesomeIcon icon={faEllipsisVertical} />}
          onClick={(e) => {
            e.stopPropagation();
            handleClickModal();
          }}
        />
        <CardPopover
          anchorEl={anchorEl}
          changeDocumentStatus={changeDocumentStatus}
          doc={doc}
          handleCloseActionsPopup={handleCloseActionsPopup}
          handleDocumentRestore={handleDocumentRestore}
          handleDocumentsDelete={handleDocumentsDelete}
          handleMoveToBin={handleMoveToBin}
          isDeleteDocumentsLoading={isDeleteDocumentsLoading}
          isMoveToBinLoading={isMoveToBinLoading}
          loadingChangeDocumentStatus={loadingChangeDocumentStatus}
          open={open}
          restoreLoading={restoreLoading}
          workspaceId={workspaceId}
        />
      </Stack>
    </>
  );
};

export default ActionCell;
